var map = {
	"./en.article1.json": 44,
	"./en.article10.json": 8527,
	"./en.article2.json": 8157,
	"./en.article3.json": 857,
	"./en.article4.json": 2458,
	"./en.article5.json": 4129,
	"./en.article6.json": 9957,
	"./en.article7.json": 9110,
	"./en.article8.json": 5422,
	"./en.article9.json": 6685,
	"./en.json": 1008,
	"./ua.article1.json": 2676,
	"./ua.article10.json": 9762,
	"./ua.article2.json": 3442,
	"./ua.article3.json": 8502,
	"./ua.article4.json": 6540,
	"./ua.article5.json": 6969,
	"./ua.article6.json": 1357,
	"./ua.article7.json": 1562,
	"./ua.article8.json": 7938,
	"./ua.article9.json": 8080,
	"./ua.json": 8391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4678;